import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Module } from './module';

const routes: Routes = [
  {
    path: 'module',
    component: Module,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ModuleRoutingModule {}
